import React from 'react';
import { Col, Row } from 'react-bootstrap';
import displayCurrency from '../../../../../../helpers/displayCurrency';
import formatDateTime from '../../../../../../helpers/formatDateTime';

const parseReference = (reference) => {
  try {
    const parsedReference = JSON.parse(reference);
    if (typeof parsedReference === 'string' || typeof parsedReference === 'number') {
      return parsedReference;
    }
    return `${parsedReference?.transactionId ?? ''} / ${parsedReference.tokenId ?? ''}`;
  } catch (e) {
    return reference;
  }
};
const Transactions = ({ transactions }) => {
  if (!transactions || !transactions.length) {
    return null;
  }

  return (
    <div>
      <Row>
        <Col sm={12} className="section-title">
          <h4>Transactions</h4>
        </Col>
        <Col sm={12}>
          {transactions.map((transaction) => {
            const transactionAttributes = transaction.attributes;

            const reference = parseReference(transactionAttributes.reference);
            return (
              <div className="form-horizontal" key={transaction.id}>
                <Row>
                  <Col sm={2}>{formatDateTime(transactionAttributes.transacted_at)}</Col>
                  <Col sm={2}>
                    <span className={'capitalise'}>
                      {transactionAttributes.source === 'payment gateway'
                        ? 'Card'
                        : transactionAttributes.source}
                    </span>
                  </Col>
                  <Col sm={2}>
                    <span className="premium">
                      {displayCurrency(
                        transactionAttributes.amount,
                        transactionAttributes.currency,
                      )}
                    </span>
                  </Col>
                  <Col sm={2}>
                    <span className={'capitalise'}>{transactionAttributes.status}</span>
                  </Col>
                  <Col sm={4}>{reference}</Col>
                </Row>
              </div>
            );
          })}
        </Col>
      </Row>
      <div className="hr" />
    </div>
  );
};
export default Transactions;
